import { Col, Modal, Row, Upload } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import React, { useState } from 'react';
import ImgCrop from 'antd-img-crop';

const COEPictureUploader = ({ fileList, setFileList, setImageBase64, setCounter, counter }) => {
	// const [errorFileType, setErrorFileType] = useState(false);
	const [previewOpen, setPreviewOpen] = useState(false);
	const [previewImage, setPreviewImage] = useState('');
	const [previewTitle, setPreviewTitle] = useState('');

	const getBase64 = (file) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});

	const handleCancel = () => setPreviewOpen(false);
	const handlePreview = async (file) => {
		setPreviewImage(file.url || file.thumbUrl);
		setPreviewOpen(true);
		setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
	};

	const props = {
		multiple: false,
		onRemove: () => {
			setFileList([]);
		},
		beforeUpload: async (file) => {
			const base64 = await getBase64(file);

			const imageObj = {
				uid: file.uid,
				lastModified: file.lastModified,
				lastModifiedDate: file.lastModifiedDate,
				name: file.name,
				size: file.size,
				type: file.type,
				percent: 0,
				originFileObj: file,
				thumbUrl: base64,
			};

			setFileList([imageObj]);
			setImageBase64(base64);
			setCounter({
				...counter,
				picture: 1,
			});

			return false;
		},
		fileList,
		accept: '.jpg, .jpeg, .png',
		listType: 'picture-card',
		onPreview: handlePreview,
	};

	return (
		<Content>
			<ImgCrop showGrid showReset rotationSlider>
				<Upload {...props}>{fileList?.length < 1 && 'Upload'}</Upload>
			</ImgCrop>
			<Row gutter={[16, 12]}>
				<Col xs={24} sm={24} md={24} xl={24}></Col>
				<Modal open={previewOpen} title={previewTitle} footer={null} zIndex={9999} onCancel={handleCancel}>
					<img
						alt="example"
						style={{
							width: '100%',
						}}
						src={previewImage}
					/>
				</Modal>
			</Row>
		</Content>
	);
};

export default COEPictureUploader;
